import { useTenantInstance } from "../hooks/useTenantInstance";
import { useLoadDisplayTzPrefs } from "../hooks/useDisplayTz";

/**
 * App-level connector (renders nothing): loads the viewer's display-tz prefs
 * (personal tz + mode + instance tz) once per instance into the userPreferences
 * slice, so every `useDisplayTz` across CRM + Advisor reads the resolved zone
 * without re-fetching. Mounted in AppLayout next to the other connectors.
 *
 * This is what supersedes the hardcoded `setInstanceTimezone("US/Pacific")` for
 * DISPLAY — the seam reads this slice, never authSlice.instanceSettings.timezone.
 */
export function DisplayTzLoader(): null {
  const { selectedInstanceId } = useTenantInstance();
  useLoadDisplayTzPrefs(selectedInstanceId);
  return null;
}
